var map = {
	"./@2x/about/banner.jpg": 3606,
	"./@2x/about/blur_background.jpg": 4887,
	"./@2x/about/caojie.jpg": 2312,
	"./@2x/about/circle_core_en.png": 9651,
	"./@2x/about/circle_core_zh.png": 3008,
	"./@2x/about/gradient_background.jpg": 1043,
	"./@2x/about/kevin_zhu.jpg": 3357,
	"./@2x/about/lunfei_liang.jpg": 3427,
	"./@2x/about/luo_xianshu.jpg": 7039,
	"./@2x/about/micowell_logo.png": 8972,
	"./@2x/about/partners.png": 6713,
	"./@2x/about/wubin_zhou.jpg": 1324,
	"./@2x/about/xu_song.jpg": 7221,
	"./@2x/about/yunzhong_cheng.jpg": 4790,
	"./@2x/about/zhixuan_yin.jpg": 7265,
	"./@2x/background_logo.svg": 3792,
	"./@2x/index/adjust_strength_background_placeholder.jpg": 4920,
	"./@2x/index/app_frame.png": 1394,
	"./@2x/index/app_image_1.png": 8092,
	"./@2x/index/app_image_2.png": 5489,
	"./@2x/index/app_image_3.png": 7372,
	"./@2x/index/arrow_up_down.png": 1612,
	"./@2x/index/background_p6.jpg": 979,
	"./@2x/index/banner_1.jpg": 9012,
	"./@2x/index/banner_2.jpg": 7335,
	"./@2x/index/banner_3.jpg": 6197,
	"./@2x/index/chart_placeholder.png": 6259,
	"./@2x/index/control_mode_man.png": 7999,
	"./@2x/index/download_phone.png": 2317,
	"./@2x/index/fancy_xmai.png": 2141,
	"./@2x/index/hand_left.png": 6119,
	"./@2x/index/hand_right.png": 8588,
	"./@2x/index/handle.png": 3459,
	"./@2x/index/handle_horizonal.png": 7271,
	"./@2x/index/handle_vertical.png": 624,
	"./@2x/index/motor_control_scroll_left.jpg": 2297,
	"./@2x/index/motor_control_scroll_right.jpg": 668,
	"./@2x/index/motor_scroll_placeholder.png": 9502,
	"./@2x/index/phone.png": 566,
	"./@2x/index/phone_app_placeholder.png": 3531,
	"./@2x/index/puller.png": 7043,
	"./@2x/index/qr_code_placeholder.jpg": 21,
	"./@2x/index/top_video_placeholder.jpg": 6269,
	"./@2x/index/training_1.jpg": 4203,
	"./@2x/index/training_2.jpg": 2732,
	"./@2x/index/training_3.jpg": 2673,
	"./@2x/index/training_4.jpg": 3598,
	"./@2x/index/training_5.jpg": 141,
	"./@2x/index/training_new_1.jpg": 5474,
	"./@2x/index/training_new_10.jpg": 2060,
	"./@2x/index/training_new_11.jpg": 8502,
	"./@2x/index/training_new_12.jpg": 8949,
	"./@2x/index/training_new_13.jpg": 3424,
	"./@2x/index/training_new_14.jpg": 8978,
	"./@2x/index/training_new_2.jpg": 2694,
	"./@2x/index/training_new_3.jpg": 7096,
	"./@2x/index/training_new_4.jpg": 1219,
	"./@2x/index/training_new_5.jpg": 8104,
	"./@2x/index/training_new_6.jpg": 3317,
	"./@2x/index/training_new_7.jpg": 6888,
	"./@2x/index/training_new_8.jpg": 7513,
	"./@2x/index/training_new_9.jpg": 7736,
	"./@2x/index/xmai_banner.png": 9899,
	"./@2x/index/xmai_pink.png": 5559,
	"./@2x/index/xmai_stand.png": 7300,
	"./@2x/index/xmai_unfold_black.png": 2300,
	"./@2x/logo.svg": 3341,
	"./@2x/logo_small.svg": 4269,
	"./@2x/product_middle_banner.jpg": 1630,
	"./@2x/product_top_banner.jpg": 4296,
	"./@2x/product_top_banner_new.jpg": 1344,
	"./@2x/product_top_banner_new_new.jpg": 3330,
	"./@2x/xmai_wechat.png": 5436,
	"./about/banner.jpg": 9811,
	"./about/blur_background.jpg": 9007,
	"./about/caojie.jpg": 1780,
	"./about/circle.png": 3608,
	"./about/circle_core_en.png": 2456,
	"./about/circle_core_zh.png": 5024,
	"./about/gradient_background.jpg": 5170,
	"./about/kevin_zhu.jpg": 7054,
	"./about/lunfei_liang.jpg": 2878,
	"./about/luo_xianshu.jpg": 3524,
	"./about/micowell_logo.png": 8474,
	"./about/partners.png": 3407,
	"./about/wubin_zhou.jpg": 591,
	"./about/xu_song.jpg": 1451,
	"./about/yunzhong_cheng.jpg": 6355,
	"./about/zhixuan_yin.jpg": 6179,
	"./background_logo.svg": 1889,
	"./gif/adaptive.gif": 7875,
	"./gif/adjust_strength_man.gif": 854,
	"./gif/constant.gif": 2897,
	"./gif/decreasing.gif": 8170,
	"./gif/handle_vertical_gif.gif": 8126,
	"./gif/increasing.gif": 5935,
	"./gif/power_bar.gif": 8299,
	"./gif/scroll.gif": 5230,
	"./gif/scroll_new.gif": 5115,
	"./gif/scroll_new_new.gif": 4099,
	"./gif/scroll_new_new_mobile.gif": 1896,
	"./gif/spring.gif": 6215,
	"./gif/xmai_gif.gif": 5957,
	"./gif/xmai_gif_colors.gif": 7789,
	"./gif/xmai_gif_once.gif": 9503,
	"./index/T槽图片.png": 4546,
	"./index/adjust_strength_background_placeholder.jpg": 2046,
	"./index/app_frame.png": 7828,
	"./index/app_image_1.png": 8034,
	"./index/app_image_2.png": 7539,
	"./index/app_image_3.png": 704,
	"./index/arrow_up_down.png": 8525,
	"./index/background_p6.jpg": 6462,
	"./index/banner_1.jpg": 4711,
	"./index/banner_2.jpg": 403,
	"./index/banner_3.jpg": 2865,
	"./index/cable.png": 6625,
	"./index/chart_placeholder.png": 7068,
	"./index/control_mode_chart_placeholder.jpg": 6145,
	"./index/control_mode_man.png": 8269,
	"./index/control_mode_man_mobile.png": 3432,
	"./index/control_mode_weman.png": 3029,
	"./index/download_phone.png": 7066,
	"./index/fancy_xmai.png": 9248,
	"./index/hand_left.png": 9466,
	"./index/hand_right.png": 8438,
	"./index/handle.png": 1241,
	"./index/handle_horizonal.png": 1671,
	"./index/handle_vertical.png": 1399,
	"./index/motor_control_scroll_left.jpg": 8688,
	"./index/motor_control_scroll_right.jpg": 9636,
	"./index/motor_scroll_placeholder.png": 3781,
	"./index/phone.png": 4404,
	"./index/phone_app_placeholder.png": 860,
	"./index/puller.png": 9996,
	"./index/qr_code_placeholder.jpg": 5430,
	"./index/top_video_placeholder.jpg": 2043,
	"./index/training_1.jpg": 4367,
	"./index/training_2.jpg": 3416,
	"./index/training_3.jpg": 9255,
	"./index/training_4.jpg": 3333,
	"./index/training_5.jpg": 6931,
	"./index/training_6.png": 3181,
	"./index/training_new_1.jpg": 4195,
	"./index/training_new_10.jpg": 4083,
	"./index/training_new_11.jpg": 7686,
	"./index/training_new_12.jpg": 3241,
	"./index/training_new_13.jpg": 4562,
	"./index/training_new_14.jpg": 8490,
	"./index/training_new_2.jpg": 435,
	"./index/training_new_3.jpg": 9820,
	"./index/training_new_4.jpg": 6083,
	"./index/training_new_5.jpg": 3406,
	"./index/training_new_6.jpg": 2548,
	"./index/training_new_7.jpg": 5903,
	"./index/training_new_8.jpg": 1059,
	"./index/training_new_9.jpg": 326,
	"./index/xmai_banner.png": 1542,
	"./index/xmai_pink.png": 349,
	"./index/xmai_stand.png": 1314,
	"./index/xmai_unfold_black.png": 7905,
	"./index/xmai_unfold_black_new.png": 170,
	"./index/展开.png": 1403,
	"./index/折叠1.png": 7528,
	"./index/折叠2.png": 8983,
	"./logo.svg": 2835,
	"./logo_small.svg": 7656,
	"./product_enjoy_assets.png": 8631,
	"./product_enjoy_background.png": 768,
	"./product_flagship_assets.png": 5186,
	"./product_flagship_background.png": 192,
	"./product_middle_banner.jpg": 932,
	"./product_standard_assets.png": 7161,
	"./product_standard_background.png": 8718,
	"./product_top_banner.jpg": 2247,
	"./product_top_banner_new.jpg": 4755,
	"./product_top_banner_new_new.jpg": 2727,
	"./product_top_banner_new_new_new.png": 9549,
	"./xmai_wechat.png": 1747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;